"use client";

import { useEffect } from "react";
import HomeAuthModal from "./HomeAuthModal";
import type { AppConfig } from "../config/get-config";
import api from "../services/api";

export default function HomeClientInit({
  appConfig,
}: {
  appConfig: AppConfig;
}) {
  useEffect(() => {
    api.defaults.baseURL = appConfig.apiUrl;
  }, [appConfig]);

  return (
    <>
      <HomeAuthModal config={appConfig} />
    </>
  );
}
